<template>
<div class="login-page">
    <img v-if="refreshDom" class="login-bg" :src="file[fileId]"/>
    <div class="forget-main">
      <button @click="back" class="forget-back">x</button>
      <div class="forget-title">{{ $t('Auth.contact') }}</div>
      <div class="forget-info" v-if="showForm2">
        <b-container fluid>
          <b-row class="forget-row">
            <b-col sm="4">
              <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'title') }}:</label>
            </b-col>
            <b-col sm="8">
              <b-form-select v-model="selected" :options="title" class="forget-inputslct"></b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="isfreeze" class="freeze">
            <label>*账号冻结说明：每个账号只可冻结一次，期限为三个月。三个月后将自动解冻并开始扣除使用期限。可以选择提前解冻，但是也会消耗冻结机会。请仔细考虑是否冻结！</label>
          </b-row>
          <b-row class="forget-row">
            <b-col sm="4">
              <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'number') }}:</label>
            </b-col>
            <b-col sm="8">
              <b-form-input v-model="number" class="forget-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="forget-row">
            <b-col sm="4">
              <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'main') }}:</label>
            </b-col>
            <b-col sm="8">
              <b-form-textarea v-model="main" class="forget-inputarea"></b-form-textarea>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="forget-buttong">
        <b-button class="forget-button" variant="outline-light" @click="reset">{{ $t('Common.reset') }}</b-button>
        <b-button class="forget-button" variant="outline-light" @click="submit">{{ $t('Common.submit') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import axios from '@/api/config'
import { Alert } from 'vue-m-dialog'
import { contactAPI } from '@/api/authAPI'

const ContactCard = Vue.extend({
  name: 'ContactCard',
  data () {
    return {
      refreshDom: true,
      // selected: null,
      show: true,
      fileId: 1002,
      showForm1: 0,
      showForm2: true,
      showForm3: false,
      rmber: null,
      number: '',
      title: [
        { value: null, text: '选择一个主题', disabled: true },
        { value: '账号问题', text: '账号问题' },
        { value: '账号续费', text: '账号续费' },
        { value: '课程查询', text: '课程查询' },
        { value: '账号冻结', text: '账号冻结' },
        { value: '账号解冻', text: '账号解冻' },
        { value: '其他', text: '其他' }
      ],
      main: '',
      count: 0,
      selected: '',
      isfreeze: false,
      type: '',
      oldnum: 0
    }
  },
  computed: {
    ...mapState({
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size'
    })
    // number: {
    //   get: function () { return this.oldnum },
    //   set: function (newv) { this.oldnum = newv.replace(/[^/d]/g, '') }
    // }
  },
  mounted () {
    if (!this.$store.state.resource.status[this.fileId]) {
      this.$store.dispatch('resource/getFileTypePublic', this.fileId)
    }
    this.type = window.opener['filter']
    if (this.type === 'buy') {
      this.selected = '账号续费'
      this.number = localStorage.userNumber
      this.main = '该账号需要续费'
    }
  },
  watch: {
    isFileChange () {
      this.refresh()
    },
    email () {
      if (this.email !== null) {
        this.showForm3 = true
      }
    },
    selected () {
      if (this.selected === '账号冻结' || this.selected === '账号解冻') {
        this.isfreeze = true
      } else {
        this.isfreeze = false
      }
    }
  },
  methods: {
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    },
    reset () {
      this.selected = null
      this.number = ''
      this.main = ''
    },
    submit () {
      // console.log(this.selected)
      // console.log(this.number)
      // console.log(this.main)
      if (this.number !== '') this.count++
      if (this.selected !== '') this.count++
      if (this.main !== '') this.count++
      if (this.count >= 3) {
        if (isNaN(this.number)) {
          Alert.alert('请检查学员编号')
        } else {
          let formData = new FormData()
          formData.append('number', this.number)
          formData.append('title', this.selected)
          formData.append('main', this.main)
          axios.post(contactAPI, formData,
            {
              transformRequest: [function (newData, headers) {
                return newData
              }]
            })
            .then((res) => {
              if (res.data.error === '01') {
                if (this.type === 'buy') {
                  // Alert.alert(this.$t('Auth.submitSuccess'))
                  //   .then(() => {
                  //     this.reset()
                  //     window.close()
                  //   })
                  alert(this.$t('Auth.submitSuccess'))
                  window.opener = null
                  window.top.open('', '_self', '')
                  window.close(this)
                } else {
                  Alert.alert(this.$t('Auth.submitSuccess'))
                  this.$router.push({
                    name: 'login'
                  })
                  this.reset()
                }
              }
              if (res.data.error === '02') {
                Alert.alert('请检查学员编号')
              }
            })
        }
      } else {
        Alert.alert(this.$t('Auth.notEnough'))
      }
    },
    back () {
      this.$router.push({
        name: 'login'
      })
    }
  }
})
export default ContactCard
</script>

<style>
.login-page {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}
.login-bg {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.forget-back {
  position: absolute;
  font-size: 20px;
  color: white;
  font-weight: 700;
  z-index: 10;
  border: 1px solid white;
  border-radius: 50%;
  height: 38px;
  width: 38px;
  top: 40px;
  left: 30px;
  background-color: #FFFFFF00;
}
.forget-back:focus {
  outline: none;
}
.forget-main {
    position: absolute;
    top: 5%;
    left: 50%;
    width: 60%;
    /* height: 700px; */
    transform: translateX(-50%);
    z-index: 2;
    padding: 30px;
    padding-bottom: 20px;
    background-color: #ffffff28;
    border-radius: 25px;
    transition: all 0.5s ease-in-out;
    text-align: center;
}
.forget-title {
    z-index: 1;
    font-size: 40px;
    color: white;
}
.forget-subtitle {
    z-index: 1;
    padding-top: 30px;
    font-size: 30px;
    color: white;
}
.forget-vendors {
  /* width: 90%; */
  z-index: 10;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.5);
}
.forget-explain {
    color: white;
    font-size: 16px;
    margin-top: 5px;
}
.forget-info {
    margin-top: 40px;
    /* text-align: left; */
    width: 80%;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
.forget-row {
  color: #eeeeee;
  font-size: 20px;
  margin-top: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
.forget-inputslct {
  border: 0;
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
}
.forget-input {
  border: 0;
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
}
.freeze {
  margin-top: 10px;
  color:#eeeeee;
  font-size: 18px;
  text-align: center;
}
.forget-inputarea {
  border: 0;
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
  /* height: 350px; */
}
.forget-inputarea:focus {
  border: 0;
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
  /* height: 350px; */
}
.forget-input:focus {
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
}
.forget-buttong {
  margin-top: 20px;
}
.forget-button {
  margin: 10px;
}
</style>
